// extracted by mini-css-extract-plugin
export default {"container":"CardItem_container__+A6FH","active":"CardItem_active__zB6S1","disabled":"CardItem_disabled__R1BUC"};